import { render } from "./privacy_page.vue?vue&type=template&id=b0648cb4&scoped=true"
const script = {}

import "./privacy_page.vue?vue&type=style&index=0&id=b0648cb4&lang=stylus&scoped=true"

import exportComponent from "/Volumes/KINDSTON/Lokal Google Drive/PROJECT/TECHSS/techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0648cb4"]])

export default __exports__